"use strict";

export const ACTION_NAMES = {
    VDP_VIEW: 'VdpView'
};

export const EVENTS = {
    VIEW: "View"
}

export const SOURCES = {
    VDP: "VDP"
}

export const VALUES_PROPERTIES = {
    LISTING_ID: "Listing:listingId",
    VEHICLE_ID: "Listing:vehicleId"
}

